/**
 * Emoji used by the UI itself (not the content packs). `scripts/copy-emoji.mjs` scans the web
 * sources (this file included) and the content package for emoji and copies the matching Twemoji
 * SVGs into `public/emoji/`. Keep every UI emoji discoverable here.
 */

/** The 6 in-game reactions, in bar order. */
export const REACTIONS = [
  { emoji: '😂', label: 'Gülmekten öldüm' },
  { emoji: '🔥', label: 'Ateş!' },
  { emoji: '😱', label: 'Şok!' },
  { emoji: '👏', label: 'Alkış' },
  { emoji: '🤑', label: 'Para saçıyor' },
  { emoji: '🍅', label: 'Domates at' },
] as const;

export type ReactionEmoji = (typeof REACTIONS)[number]['emoji'];

/** Award emoji (game over). */
export const AWARD_EMOJI = {
  esnaf: '🧿',
  mirasyedi: '💸',
  cimri: '🪙',
  sertJuri: '🔨',
  yumusakKalp: '🧸',
} as const;

/** Misc. icons used across screens. */
export const UI_EMOJI = [
  // status / chrome
  '👑',
  '🤖',
  '💰',
  '⏱️',
  '🔒',
  '🔓',
  '📋',
  '⚙️',
  '✏️',
  '🔊',
  '🔇',
  '🔉',
  '🔗',
  '📶',
  '🔌',
  '💤',
  // outcomes
  '🏆',
  '🎉',
  '🥇',
  '🥈',
  '💥',
  '✅',
  '❌',
  '⚠️',
  '💬',
  '🔵',
  '🔴',
  '🟢',
  '🟡',
  '🤝',
  // game
  '🥊',
  '🛒',
  '🎲',
  '🔀',
  '⚖️',
  '🧑‍⚖️',
  '👀',
  '🙈',
  '❓',
  '⭐',
  '🔔',
  '🎤',
  '📜',
  '📊',
  '🗳️',
  '🧾',
  '▶️',
  '⏭️',
  '↩️',
  '➕',
  '🏠',
  '🚪',
  '👥',
  '🧍',
  '🔨',
  '🎬',
  '🍽️',
  // jury faces (score badge)
  '🤮',
  '😖',
  '😕',
  '😐',
  '😋',
  '🤩',
] as const;
